<template>

	<div class="p_background">
		<div class="container_right_info">
			<div class="clearfix tb_padding">
				<div class="container_box">
					<h4 class="message_title">
			    		<span>基本信息</span>
			    	</h4>
					<section class="partition_message developer_box publick_form_box developer_basic_box">

						<!--手机号码-->
						<section class="form_box">
							<label class="form_label" for="">手机号码：</label>
							<span>{{developerInfo.telephone}}</span>
						</section>

						<!--开发者姓名-->
						<section class="form_box">
							<label class="form_label" for="">开发者姓名：</label>
							<span>{{developerInfo.devName}}</span>
						</section>

						<!--证件类型及编号-->
						<section class="form_box">
							<label class="form_label" for="">证件类型及编号：</label>
							<span>({{developerInfo.cardType}}){{developerInfo.cardNo}}</span>
						</section>

						<!--证件照-->
						<section class="form_box">
							<label class="form_label" for="">证件照片：</label>
							<div class="example id_card_photo inline-block" id="images">
								<img :src="echoImg" alt="" class="zoomify img_default" title="证件照" id="imgz" width="234px"/>
							</div>
							<div class="example id_card_photo inline-block" id="imagesf">
								<img :src="echoImg1" alt="" class="zoomify img_default" title="证件照" id="imgf" width="234px"/>
							</div>
						</section>

					</section>
				</div>

				<div class="container_box">
					<h4 class="message_title">
			    		<span>结算方式</span>
			    	</h4>
			    	<section class="partition_message developer_box publick_form_box developer_basic_box">
						<!--开户行-->
						<section class="form_box">
							<label class="form_label" for="">开户行：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.bankType}}</span>
						</section>
						<!--开户支行-->
						<section class="form_box">
							<label class="form_label" for="">开户支行：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.bankBranch}}</span>
						</section>
						<!--卡号-->
						<section class="form_box">
							<label class="form_label" for="">银行卡号：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.cardNo}}</span>
						</section>
						<!--开户名-->
						<section class="form_box">
							<label class="form_label" for="">开户名：</label>
							<span v-if="tCloudUserBankcard != null">{{tCloudUserBankcard.cardUsername}}</span>
						</section>
					</section>
				</div>
				
				<div class="container_box">
					<h4 class="message_title">
			    		<span>联系方式</span>
			    	</h4>
			    	
					<section class="partition_message developer_box publick_form_box developer_basic_box">

						<!--联系地址-->
						<section class="form_box">
							<label class="form_label" for=""><i class="must_color">*</i>联系地址：</label>
							<span>{{developerInfo.sites}}</span>
						</section>

						<!--电子邮箱-->
						<section class="form_box">
							<label class="form_label" for=""><i class="must_color">*</i>电子邮箱：</label>
							<span>{{developerInfo.email}}</span>
						</section>

						<!--手机号码-->
						<section class="form_box">
							<label class="form_label" for=""><i class="must_color">*</i>手机号码：</label>
							<span>{{developerInfo.telephone}}</span>
						</section>

						<!--其他号码-->
						<section class="form_box">
							<label class="form_label" for="">其他手机或电话号码：</label>
							<span>{{developerInfo.otherphone}}</span>
						</section>

						<!--QQ-->
						<section class="form_box">
							<label class="form_label" for="">QQ：</label>
							<span>{{developerInfo.qq}}</span>
						</section>

						<!--官网地址-->
						<section class="form_box">
							<label class="form_label" for="">官网地址：</label>
							<span>{{developerInfo.blogUrl}}</span>
						</section>

					</section>
				</div>
				<!-- container_box/ -->

			</div>
		</div>
	</div>

</template>

<script>
    export default {
        name: 'developer_data',
        data () {
            return {
            	imgH:'',
            	imgW:'',
            	echoImg:'',
            	echoImg1:'',
            	developerInfo:{
            		telephone:'',
            		devName:'',
            		cardType:'',
            		cardNo:'',
            		photoUrl:'',
            		accountType:'',
            		sites:'',
            		email:'',
            		otherphone:'',
            		qq:'',
            		blogUrl:''
            	},
            	tCloudUserDeveloper: {
            		developerName:"",
            		cardType:"",
            		cardNo:"",
            		photoPath:"",
            		addressDetails:"",
            		email:"",
            		mobile:"",
            		spareMobile:"",
            		qq:"",
            		blogUrl:""
            	},
            	tCloudUserBankcard:""
            }
        },
        created: function () {
			this.getPersonalInfo();
        },
        mounted: function (){
        	this.imgFd()
        },
        computed:{
        	
        },
        methods: {
        	imgFd(){
        		$('.example img').zoomify();
        	},
        	//获取个人信息
        	getPersonalInfo(){
        		var temp = this;
				this.$http.post('/zklccloud/developerInfo',{ emulateJSON: true }).then(function(m) {
					temp.developerInfo = m.body.content.developerInfoDTO;
					temp.tCloudUserBankcard = m.body.content.tCloudUserBankcard,
					temp.echoImg=m.body.content.developerInfoDTO.photoUrl;
					if(m.body.content.developerInfoDTO.photoUrlNegative == ''){
						$("#imagesf").hide();
					}else{
						temp.echoImg1=m.body.content.developerInfoDTO.photoUrlNegative;
					}
				})
        	}
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// developer_data.vue?788cff18